import { useEffect } from 'react';
import { useWhenMounted } from '../useWhenMounted';
export function useLockedBody({ state }) {
    useWhenMounted(() => {
        document.body.style.overflow = state ? 'hidden' : 'initial';
    }, [state]);
    useEffect(() => {
        return () => {
            document.body.style.overflow = 'initial';
        };
    }, []);
}
//# sourceMappingURL=index.js.map